import { createSlice } from '@reduxjs/toolkit';


interface IContextState {
  list: string[];
  tabs: any[];
  initialTab: string;
  onSetTab?: (val: string) => void;
  customTitles?: string[];
  anchorLinks: any[];
  anchorsLimit: number,
  anchorsOverrideNavigation: false,
}

const initialState = {
  list: [],
  tabs: [],
  customTitles: [],
  initialTab: '',
  onSetTab: null,
  anchorLinks: [],
  anchorsLimit: 0,
  anchorsOverrideNavigation: false,
};

export const HseContextListSlice = createSlice({
  name: 'contextList',
  initialState,
  reducers: {
    set: (state, action) => {
      if (action.payload && Object.keys(action.payload)?.length > 0) {
        const { tabs, initialTab, onSetTab, customTitles } = action.payload;
        //@ts-ignore
        state.list = Object.keys(tabs);
        state.tabs = tabs;
        state.customTitles = customTitles
        state.initialTab = initialTab;
        state.onSetTab = onSetTab
      }
    },
    reset: (state, action) => {
      state.list = initialState.list
      state.tabs = initialState.tabs
      state.customTitles = initialState.customTitles
      state.initialTab = initialState.initialTab;
      state.onSetTab = initialState.onSetTab;
    },
    setAnchorLinks: (state, action) => {
      state.anchorLinks = action.payload.anchors;
      state.anchorsLimit = action.payload.limit;
      state.anchorsOverrideNavigation = action.payload.override;
    },
    resetAnchorLinks: (state) => {
      state.anchorLinks = initialState.anchorLinks;
      state.anchorsLimit = initialState.anchorsLimit;
      state.anchorsOverrideNavigation = initialState.anchorsOverrideNavigation;
    },
  }
  // extraReducers: {}
});

export default HseContextListSlice
export const HseContextActions = HseContextListSlice.actions
export const HseContextSelector = (store: { contextList: IContextState }): IContextState => store.contextList;
import { createSlice } from '@reduxjs/toolkit';


interface IContextState {
  list: string[];
  tabs: any[];
  initialTab: string;
  onSetTab?: (val: string) => void;
  customTitles?: string[];
  anchorLinks: any[];
  anchorsLimit: number,
  anchorsOverrideNavigation: false,
}

const initialState = {
  list: [],
  tabs: [],
  customTitles: [],
  initialTab: '',
  onSetTab: null,
  anchorLinks: [],
  anchorsLimit: 0,
  anchorsOverrideNavigation: false,
};

export const HseContextListSlice = createSlice({
  name: 'contextList',
  initialState,
  reducers: {
    set: (state, action) => {
      if (action.payload && Object.keys(action.payload)?.length > 0) {
        const { tabs, initialTab, onSetTab, customTitles } = action.payload;
        //@ts-ignore
        state.list = Object.keys(tabs);
        state.tabs = tabs;
        state.customTitles = customTitles
        state.initialTab = initialTab;
        state.onSetTab = onSetTab
      }
    },
    reset: (state, action) => {
      state.list = initialState.list
      state.tabs = initialState.tabs
      state.customTitles = initialState.customTitles
      state.initialTab = initialState.initialTab;
      state.onSetTab = initialState.onSetTab;
    },
    setAnchorLinks: (state, action) => {
      state.anchorLinks = action.payload.anchors;
      state.anchorsLimit = action.payload.limit;
      state.anchorsOverrideNavigation = action.payload.override;
    },
    resetAnchorLinks: (state) => {
      state.anchorLinks = initialState.anchorLinks;
      state.anchorsLimit = initialState.anchorsLimit;
      state.anchorsOverrideNavigation = initialState.anchorsOverrideNavigation;
    },
  }
  // extraReducers: {}
});

export default HseContextListSlice
export const HseContextActions = HseContextListSlice.actions
export const HseContextSelector = (store: { contextList: IContextState }): IContextState => store.contextList;
